<div class="ha" [class.editando]="modoEdicion">

  <!-- ============================================================
       Encabezado
       ============================================================ -->
  <header class="ha-head">
    <div class="ha-head-txt">
      <span class="ha-eyebrow">ISO/IEC 42001 &middot; Formato FOS-005</span>
      <h2>Hojas de apoyo</h2>
      <p class="ha-sub">Estrategias &middot; Ejemplo de amenazas &middot; Apreciación de riesgos &middot; Criterios de evaluación</p>
      <p class="ha-nota-head">
        Esto es <b>la misma información</b> que la Matriz de Riesgos IA usa para calcular y la
        que muestra en su ventana de <b>Hojas de apoyo</b>. No hay copia intermedia: el cambio
        se ve allá en cuanto se vuelve a abrir esa ventana.
      </p>
    </div>

    <div class="ha-head-acc">
      <span class="ha-estado" [class.ha-estado-edit]="modoEdicion">
        {{ modoEdicion ? 'Editando' : 'Sólo lectura' }}
      </span>
      <button type="button" class="ha-btn-modo" [class.activo]="modoEdicion"
              (click)="alternarModoEdicion()">
        {{ modoEdicion ? 'Terminar edición' : 'Editar' }}
      </button>
    </div>
  </header>

  <!-- ============================================================
       Datos del formato FOS-005 (29/09/2026): título, organización,
       versión y fecha de liberación. Los mismos para todas las
       matrices: salen en el encabezado de cada una y en su Excel.
       ============================================================ -->
  <section class="ha-tarjeta ha-formato" *ngIf="!cargando && !editandoFormato">
    <span class="material-icons ha-formato-ico" aria-hidden="true">description</span>
    <div class="ha-formato-txt">
      <span class="ha-formato-et">Datos del formato</span>
      <b class="ha-formato-titulo">{{ formato.titulo }}</b>
      <span class="ha-formato-meta">
        {{ formato.organizacion }}
        <span class="ha-formato-sep">&middot;</span>
        Formato <b>V {{ formato.version }}</b>
        <span class="ha-formato-sep">&middot;</span>
        Liberado el <b>{{ fechaFormato(formato.liberacion) }}</b>
      </span>
    </div>
    <button type="button" class="ha-btn-edit" *ngIf="modoEdicion" (click)="editarFormato()"
            [disabled]="!!edicion">Editar datos del formato</button>
  </section>

  <section class="ha-tarjeta ha-alta ha-formato-form en-edicion" *ngIf="editandoFormato && formatoBorrador">
    <div class="ha-alta-tit">Datos del formato</div>
    <div class="ha-alta-grid">
      <label class="ancha">
        <span>Título del formato *</span>
        <input type="text" class="ha-in" maxlength="150" [(ngModel)]="formatoBorrador.titulo"
               [disabled]="guardando" placeholder="FOS-005 Plan de Respuesta al Riesgo">
      </label>
      <label>
        <span>Organización *</span>
        <input type="text" class="ha-in" maxlength="150" [(ngModel)]="formatoBorrador.organizacion"
               [disabled]="guardando" placeholder="Centro Operativo Solser">
      </label>
      <label class="corta">
        <span>Versión del formato *</span>
        <input type="text" class="ha-in" maxlength="11" [(ngModel)]="formatoBorrador.version"
               [disabled]="guardando" placeholder="1.17">
      </label>
      <label class="corta">
        <span>Fecha de liberación *</span>
        <input type="date" class="ha-in" [(ngModel)]="formatoBorrador.liberacion" [disabled]="guardando">
      </label>
    </div>
    <p class="ha-explica ha-formato-nota">
      Salen en el encabezado de todas las matrices y en su Excel. No es la versión de cada
      documento: esa se lleva en su <b>Historial de cambios</b>.
    </p>
    <div class="ha-alta-pie">
      <button type="button" class="ha-btn-ok" (click)="guardarFormato()" [disabled]="guardando">
        {{ guardando ? 'Guardando…' : 'Guardar' }}
      </button>
      <button type="button" class="ha-btn-no" (click)="cancelarFormato()" [disabled]="guardando">Cancelar</button>
    </div>
  </section>

  <div class="ha-nav">
    <button type="button" *ngFor="let s of secciones" class="ha-pestana"
            [class.activa]="pestana === s.clave" (click)="cambiarPestana(s.clave)">
      <span class="ha-pestana-tit">{{ s.titulo }}</span>
      <span class="ha-pestana-pie">{{ s.pie }}</span>
    </button>
  </div>

  <div class="ha-msg ha-error" *ngIf="error">{{ error }}</div>
  <div class="ha-msg ha-ok" *ngIf="aviso && !error">{{ aviso }}</div>
  <div class="ha-cargando" *ngIf="cargando">Cargando catálogos…</div>

  <!-- ============================================================
       1. ESTRATEGIAS
       ============================================================ -->
  <section class="ha-hoja" *ngIf="!cargando && pestana === 'estrategias'">

    <!-- La hoja del Excel trae dos partes: el riesgo con sus estrategias
         y los criterios de evaluación. Sub-páginas para no amontonar. -->
    <div class="exl-subnav">
      <button type="button" *ngFor="let s of seccionesEst" class="exl-subtab"
              [class.activa]="seccionEst === s.clave"
              (click)="elegirSeccionEst(s.clave)">{{ s.titulo }}</button>
    </div>

    <ng-container *ngIf="seccionEst === 'estrategias'">



    <!-- La introduccion de la hoja del Excel: que es un riesgo. -->
    <div class="ha-tarjeta exl-caja est-intro-caja"
         [class.en-edicion]="editandoFila(introFila('INTRO_EST_TITULO')) || editandoFila(introFila('INTRO_EST_CUERPO'))">
      <div class="exl-cab est-intro-cab">
        <ng-container *ngIf="!editandoFila(introFila('INTRO_EST_TITULO'))">
          <span class="est-intro-tit">{{ introTitulo() }}</span>
          <span class="est-acc" *ngIf="modoEdicion && introFila('INTRO_EST_TITULO')">
            <button type="button" class="est-btn" (click)="editar('APOYO_LISTA', introFila('INTRO_EST_TITULO'))"
                    [disabled]="!!edicion">Editar título</button>
          </span>
        </ng-container>
        <ng-container *ngIf="editandoFila(introFila('INTRO_EST_TITULO'))">
          <input aria-label="Título" type="text" class="ha-in exl-in" [(ngModel)]="borrador.texto"
                 [maxlength]="lim.apoyoTexto" [disabled]="guardando">
          <button type="button" class="ha-btn-ok chico" (click)="guardar()" [disabled]="guardando">&#10003;</button>
          <button type="button" class="ha-btn-no chico" (click)="cancelar()" [disabled]="guardando">&#10005;</button>
        </ng-container>
      </div>

      <ng-container *ngIf="!editandoFila(introFila('INTRO_EST_CUERPO'))">
        <p class="est-texto est-intro">{{ introCuerpo() }}</p>
        <div class="est-intro-pie" *ngIf="modoEdicion && introFila('INTRO_EST_CUERPO')">
          <button type="button" class="ha-btn-edit" (click)="editar('APOYO_LISTA', introFila('INTRO_EST_CUERPO'))"
                  [disabled]="!!edicion">Editar texto</button>
        </div>
      </ng-container>
      <div class="est-edit" *ngIf="editandoFila(introFila('INTRO_EST_CUERPO'))">
        <textarea aria-label="Texto" class="ha-in" rows="10" [(ngModel)]="borrador.texto"
                  [maxlength]="lim.introCuerpo" [disabled]="guardando"></textarea>
        <div class="ha-alta-pie">
          <button type="button" class="ha-btn-ok" (click)="guardar()" [disabled]="guardando">Guardar</button>
          <button type="button" class="ha-btn-no" (click)="cancelar()" [disabled]="guardando">Cancelar</button>
        </div>
      </div>
    </div>

    <div class="ha-tit">
      <h3>Estrategias de respuesta al riesgo</h3>
      <button type="button" class="ha-btn-alta" *ngIf="modoEdicion"
              (click)="agregar('ESTRATEGIA')" [disabled]="!!edicion">+ Agregar estrategia</button>
    </div>
    <p class="ha-explica">
      Es lo que se elige en el campo <em>Estrategia</em> de cada riesgo del Plan de Gestión.
      Si aquí se le cambia el nombre a una estrategia, los riesgos que ya la traían se
      reapuntan solos: ahí la estrategia se guarda como texto, no por clave.
    </p>

    <!-- Alta -->
    <div class="ha-tarjeta ha-alta" *ngIf="editando('ESTRATEGIA', null)">
      <div class="ha-alta-tit">Nueva estrategia</div>
      <div class="ha-alta-grid">
        <label class="corta">
          <span>Orden</span>
          <input type="number" class="ha-in mini" [(ngModel)]="borrador.orden" [disabled]="guardando">
        </label>
        <label>
          <span>Nombre *</span>
          <input type="text" class="ha-in" [(ngModel)]="borrador.nombre"
                 [maxlength]="lim.estrategiaNombre" [disabled]="guardando">
        </label>
        <label class="corta">
          <span>Estatus</span>
          <select class="ha-in" [(ngModel)]="borrador.estatus" [disabled]="guardando">
            <option value="ACTIVO">ACTIVO</option>
            <option value="INACTIVO">INACTIVO</option>
          </select>
        </label>
        <label class="ancha">
          <span>En qué consiste</span>
          <textarea class="ha-in" rows="7" [(ngModel)]="borrador.descripcion"
                    [maxlength]="lim.estrategiaDescripcion" [disabled]="guardando"></textarea>
        </label>
      </div>
      <div class="ha-alta-pie">
        <button type="button" class="ha-btn-ok" (click)="guardar()" [disabled]="guardando">Guardar</button>
        <button type="button" class="ha-btn-no" (click)="cancelar()" [disabled]="guardando">Cancelar</button>
      </div>
    </div>

    <!-- Una tarjeta por estrategia, con el color que le da el Excel. -->
    <div class="est-card" *ngFor="let e of estrategias; trackBy: rastreaPorId"
         [class.apagado]="!activo(e)"
         [class.en-edicion]="editando('ESTRATEGIA', e.idCatEstrategia)">
      <div class="est-cab" [ngClass]="claseEstrategia(e.nombre)">
        <span class="est-num">{{ e.orden }}</span>
        <span class="est-nombre">{{ e.nombre }}</span>
        <span class="est-off" *ngIf="!activo(e)">INACTIVO</span>
        <span class="est-acc" *ngIf="modoEdicion && !editando('ESTRATEGIA', e.idCatEstrategia)">
          <button type="button" class="est-btn" (click)="editar('ESTRATEGIA', e)"
                  [disabled]="bloqueado('ESTRATEGIA', e.idCatEstrategia)">Editar</button>
          <button type="button" class="est-btn" (click)="alternarEstatus('ESTRATEGIA', e)"
                  [disabled]="bloqueado('ESTRATEGIA', e.idCatEstrategia) || guardando">
            {{ activo(e) ? 'Desactivar' : 'Activar' }}</button>
          <button type="button" class="est-btn" (click)="pedirBaja('ESTRATEGIA', e, e.nombre || '')"
                  [disabled]="bloqueado('ESTRATEGIA', e.idCatEstrategia)">Eliminar</button>
        </span>
      </div>

      <p class="est-texto" *ngIf="!editando('ESTRATEGIA', e.idCatEstrategia)">{{ e.descripcion || '—' }}</p>

      <div class="est-edit" *ngIf="editando('ESTRATEGIA', e.idCatEstrategia)">
        <div class="ha-alta-grid">
          <label class="corta">
            <span>Orden</span>
            <input type="number" class="ha-in mini" [(ngModel)]="borrador.orden" [disabled]="guardando">
          </label>
          <label>
            <span>Nombre *</span>
            <input type="text" class="ha-in" [(ngModel)]="borrador.nombre"
                   [maxlength]="lim.estrategiaNombre" [disabled]="guardando">
          </label>
          <label class="corta">
            <span>Estatus</span>
            <select class="ha-in" [(ngModel)]="borrador.estatus" [disabled]="guardando">
              <option value="ACTIVO">ACTIVO</option>
              <option value="INACTIVO">INACTIVO</option>
            </select>
          </label>
          <label class="ancha">
            <span>En qué consiste</span>
            <textarea class="ha-in" rows="9" [(ngModel)]="borrador.descripcion"
                      [maxlength]="lim.estrategiaDescripcion" [disabled]="guardando"></textarea>
          </label>
        </div>
        <div class="ha-alta-pie">
          <button type="button" class="ha-btn-ok" (click)="guardar()" [disabled]="guardando">Guardar</button>
          <button type="button" class="ha-btn-no" (click)="cancelar()" [disabled]="guardando">Cancelar</button>
        </div>
      </div>
    </div>

    <p class="vacio" *ngIf="estrategias.length === 0 && !editando('ESTRATEGIA', null)">
      Todavía no hay estrategias capturadas.
    </p>
    </ng-container>

    <!-- Criterios de evaluación como los trae la hoja del Excel:
         tabla grande de probabilidad, categorías de impacto y trio. -->
    <ng-container *ngIf="seccionEst === 'criterios'">



    <!-- ==========================================================
         Como la hoja "Estrategias" del Excel: la tabla grande de
         probabilidad, la de categorias de impacto (con proposito y
         partes interesadas) y el trio-resumen con colores vivos.
         ========================================================== -->

    <!-- 1) Criterios para la evaluacion del riesgo (probabilidad) -->
    <ng-container *ngTemplateOutlet="cabeceraApoyo; context: { lista: 'TIT_CRIT_PROB', respaldo: 'Criterios para la evaluación del riesgo', titulo: true }"></ng-container>
    <div class="exl-toolbar" *ngIf="modoEdicion">
      <button type="button" class="ha-btn-alta" (click)="agregarSeveridadPara('PROBABILIDAD')"
              [disabled]="!!edicion">+ Agregar nivel de probabilidad</button>
    </div>

    <div class="ha-tarjeta ha-alta" *ngIf="editandoTipo('SEVERIDAD') && borrador && borrador.aplicaA !== 'IMPACTO'">
      <ng-container *ngTemplateOutlet="panelSeveridad"></ng-container>
    </div>

    <div class="ha-tarjeta">
      <table class="ha-tabla">
        <thead>
          <tr>
            <th>Descripción</th>
            <th class="w-corta c">Probabilidad</th>
            <th class="w-mini c">Nivel</th>
            <th class="w-corta c">Estatus</th>
            <th class="w-acciones" *ngIf="modoEdicion">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let s of severidadDesc('PROBABILIDAD'); trackBy: rastreaPorId"
              [class.en-edicion]="editando('SEVERIDAD', s.idCatSeveridad)"
              [class.apagado]="!activo(s)">
            <ng-container *ngIf="!editando('SEVERIDAD', s.idCatSeveridad) || origenEdicion === 'trio'">
              <ng-container *ngTemplateOutlet="celdasSeveridad; context: { $implicit: s }"></ng-container>
            </ng-container>
            <ng-container *ngIf="editando('SEVERIDAD', s.idCatSeveridad) && origenEdicion !== 'trio'">
              <td><textarea aria-label="Descripción" class="ha-in" rows="3" [(ngModel)]="borrador.descripcion"
                            [maxlength]="lim.severidadDescripcion"></textarea></td>
              <ng-container *ngTemplateOutlet="edicionSeveridad"></ng-container>
            </ng-container>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 2) Categorias de impacto -->
    <ng-container *ngTemplateOutlet="cabeceraApoyo; context: { lista: 'TIT_CRIT_IMPACTO', respaldo: 'Categorías de Impacto', titulo: true, sep: true }"></ng-container>
    <div class="exl-toolbar" *ngIf="modoEdicion">
      <button type="button" class="ha-btn-alta" (click)="agregarSeveridadPara('IMPACTO')"
              [disabled]="!!edicion">+ Agregar categoría de impacto</button>
    </div>

    <div class="ha-tarjeta ha-alta" *ngIf="editandoTipo('SEVERIDAD') && borrador && borrador.aplicaA === 'IMPACTO'">
      <ng-container *ngTemplateOutlet="panelSeveridad"></ng-container>
    </div>

    <div class="ha-tarjeta">
      <table class="ha-tabla">
        <thead>
          <tr>
            <th class="w-media">Propósito / dirección estratégica / objetivos</th>
            <th>Partes interesadas</th>
            <th class="w-corta c">Categoría</th>
            <th class="w-mini c">Nivel</th>
            <th class="w-corta c">Estatus</th>
            <th class="w-acciones" *ngIf="modoEdicion">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let s of severidadDesc('IMPACTO'); trackBy: rastreaPorId"
              [class.en-edicion]="editando('SEVERIDAD', s.idCatSeveridad)"
              [class.apagado]="!activo(s)">
            <ng-container *ngIf="!editando('SEVERIDAD', s.idCatSeveridad) || origenEdicion === 'trio'">
              <td class="td-pre">{{ s.proposito || '—' }}</td>
              <ng-container *ngTemplateOutlet="celdasSeveridad; context: { $implicit: s }"></ng-container>
            </ng-container>
            <ng-container *ngIf="editando('SEVERIDAD', s.idCatSeveridad) && origenEdicion !== 'trio'">
              <td><textarea aria-label="Propósito / dirección estratégica / objetivos" class="ha-in" rows="4" [(ngModel)]="borrador.proposito"
                            [maxlength]="lim.severidadDescripcion"></textarea></td>
              <td><textarea aria-label="Partes interesadas" class="ha-in" rows="7" [(ngModel)]="borrador.descripcion"
                            [maxlength]="lim.severidadDescripcion"></textarea></td>
              <ng-container *ngTemplateOutlet="edicionSeveridad"></ng-container>
            </ng-container>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 3) El trio-resumen, con los colores del Excel -->
    <ng-container *ngTemplateOutlet="cabeceraApoyo; context: { lista: 'TIT_CRIT_EVAL', respaldo: 'Criterios para Evaluación de Riesgos', titulo: true, sep: true }"></ng-container>
    <div class="exl-toolbar" *ngIf="modoEdicion">
      <button type="button" class="ha-btn-alta" (click)="agregar('CLAS_SEVERIDAD')"
              [disabled]="!!edicion">+ Agregar banda de severidad</button>
    </div>

    <div class="ha-tarjeta ha-alta" *ngIf="editandoTipo('CLAS_SEVERIDAD')">
      <div class="ha-alta-tit">{{ esAlta() ? 'Nueva banda de severidad' : 'Editando la banda' }}</div>
      <div class="ha-alta-grid">
        <label class="corta">
          <span>Clasificación *</span>
          <input type="text" class="ha-in" [(ngModel)]="borrador.clasificacion"
                 [maxlength]="lim.clasificacion" [disabled]="guardando">
        </label>
        <label class="corta">
          <span>Desde (1 a 16) *</span>
          <input type="number" class="ha-in mini" min="1" max="16" [(ngModel)]="borrador.nivelDesde" [disabled]="guardando">
        </label>
        <label class="corta">
          <span>Hasta (1 a 16) *</span>
          <input type="number" class="ha-in mini" min="1" max="16" [(ngModel)]="borrador.nivelHasta" [disabled]="guardando">
        </label>
        <label class="ancha">
          <span>Criterio de aceptación</span>
          <textarea class="ha-in" rows="3" [(ngModel)]="borrador.criterioAceptacion"
                    [maxlength]="lim.criterio" [disabled]="guardando"></textarea>
        </label>
      </div>
      <div class="ha-alta-pie">
        <button type="button" class="ha-btn-ok" (click)="guardar()" [disabled]="guardando">Guardar</button>
        <button type="button" class="ha-btn-no" (click)="cancelar()" [disabled]="guardando">Cancelar</button>
      </div>
    </div>

    <!-- Editando, la rejilla se apila: la columna de Acciones no cabe en
         tres columnas y los botones salian cortados. -->
    <div class="cri3" [class.editando]="modoEdicion">
      <div class="ha-tarjeta cri3-caja">
        <ng-container *ngTemplateOutlet="cajaTrio; context: { aplica: 'PROBABILIDAD', lista: 'DEF_CRIT_PROB', respaldo: notas['criterioProbabilidad'], marcador: 'Etiqueta de probabilidad' }"></ng-container>
      </div>
      <div class="ha-tarjeta cri3-caja">
        <ng-container *ngTemplateOutlet="cajaTrio; context: { aplica: 'IMPACTO', lista: 'DEF_CRIT_IMPACTO', respaldo: notas['criterioImpacto'], marcador: 'Etiqueta de impacto' }"></ng-container>
      </div>
      <div class="ha-tarjeta cri3-caja ancha">
        <table class="ha-tabla">
          <thead>
            <tr>
              <th class="c">Severidad Riesgo</th>
              <th class="c">Probabilidad &times; Impacto</th>
              <th>Criterios de Aceptación del Riesgo según Severidad del Riesgo</th>
              <th class="w-acciones" *ngIf="modoEdicion">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let c of clasSeveridad; trackBy: rastreaPorId"
                [class.en-edicion]="editando('CLAS_SEVERIDAD', c.idCatClasSev)">
              <ng-container *ngIf="!editando('CLAS_SEVERIDAD', c.idCatClasSev)">
                <td class="c nw"><strong>{{ c.clasificacion }}</strong></td>
                <td class="c nw">{{ c.nivelDesde }} a {{ c.nivelHasta }}</td>
                <td class="td-largo td-pre" [ngClass]="claseFila(c.clasificacion)">{{ c.criterioAceptacion || '—' }}</td>
                <td class="c nw" *ngIf="modoEdicion">
                  <button type="button" class="ha-btn-edit" (click)="editar('CLAS_SEVERIDAD', c)"
                          [disabled]="bloqueado('CLAS_SEVERIDAD', c.idCatClasSev)">Editar</button>
                  <button type="button" class="ha-btn-baja"
                          (click)="pedirBaja('CLAS_SEVERIDAD', c, 'Banda ' + c.clasificacion)"
                          [disabled]="bloqueado('CLAS_SEVERIDAD', c.idCatClasSev)">Eliminar</button>
                </td>
              </ng-container>
              <ng-container *ngIf="editando('CLAS_SEVERIDAD', c.idCatClasSev)">
                <td><input aria-label="Severidad Riesgo" type="text" class="ha-in" [(ngModel)]="borrador.clasificacion"
                           [maxlength]="lim.clasificacion"></td>
                <td class="nw">
                  <input aria-label="Desde (1 a 16)" type="number" class="ha-in mini" min="1" max="16" [(ngModel)]="borrador.nivelDesde">
                  <input aria-label="Hasta (1 a 16)" type="number" class="ha-in mini" min="1" max="16" [(ngModel)]="borrador.nivelHasta">
                </td>
                <td><textarea aria-label="Criterios de Aceptación del Riesgo según Severidad del Riesgo" class="ha-in" rows="3" [(ngModel)]="borrador.criterioAceptacion"
                              [maxlength]="lim.criterio"></textarea></td>
                <td class="c nw">
                  <button type="button" class="ha-btn-ok" (click)="guardar()" [disabled]="guardando">Guardar</button>
                  <button type="button" class="ha-btn-no" (click)="cancelar()" [disabled]="guardando">Cancelar</button>
                </td>
              </ng-container>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <p class="ha-explica ha-pie">
      Es lo que se consulta desde el botón <em>Criterios de evaluación</em> del Plan de
      Gestión, y lo que ahí se ve sale de aquí. Las bandas deben cubrir del 1 al 16 sin
      huecos; el sistema no deja borrar una que dejara severidades sin clasificar.
    </p>
    </ng-container>
  </section>

  <!-- ============================================================
       2. CRITERIOS DE EVALUACIÓN (Plan de Gestión)

       Mismo acomodo y mismos colores que la ventana de Criterios del Plan de
       Gestión: probabilidad e impacto en dos tarjetas angostas y la severidad
       en una ancha, porque lleva el criterio completo. Se editan aquí, pero se
       ven exactamente igual que allá, que es donde se consultan.

       La captura NO va dentro de la tarjeta: en 190px no cabe un criterio de
       tres renglones. Se hace en el panel de arriba, y mientras tanto el
       renglón que se está tocando queda marcado en la tarjeta.
       ============================================================ -->
  <section class="ha-hoja" *ngIf="!cargando && pestana === 'criterios'">

    <div class="ha-tit">
      <h3>Criterios para evaluación de riesgos</h3>
      <div class="ha-tit-btns" *ngIf="modoEdicion">
        <button type="button" class="ha-btn-alta" (click)="agregar('SEVERIDAD')"
                [disabled]="!!edicion">+ Nivel de probabilidad o impacto</button>
        <button type="button" class="ha-btn-alta" (click)="agregar('CLAS_SEVERIDAD')"
                [disabled]="!!edicion">+ Banda de severidad</button>
      </div>
    </div>
    <p class="ha-explica">
      La <strong>severidad es probabilidad &times; impacto</strong>: ambas van del 1 al 4, así
      que la severidad resulta en escala de 1 a 16. Es lo que se consulta desde el botón
      <em>Criterios de evaluación</em> del Plan de Gestión, y lo que ahí se ve sale de aquí.
    </p>

    <!-- Panel de captura: sirve para el alta y para el cambio -->
    <div class="ha-tarjeta ha-alta" *ngIf="editandoTipo('SEVERIDAD')">
      <div class="ha-alta-tit">
        {{ esAlta() ? 'Nuevo nivel de probabilidad o impacto' : 'Editando el nivel' }}
      </div>
      <div class="ha-alta-grid">
        <label class="corta">
          <span>Aplica a *</span>
          <select class="ha-in" [(ngModel)]="borrador.aplicaA">
            <option *ngFor="let a of APLICA_SEV" [value]="a">{{ a | titlecase }}</option>
          </select>
        </label>
        <label class="corta">
          <span>Nivel (1 a 4) *</span>
          <input type="number" class="ha-in mini" min="1" max="4" [(ngModel)]="borrador.nivel">
        </label>
        <label>
          <span>Etiqueta *</span>
          <input type="text" class="ha-in" [(ngModel)]="borrador.etiqueta"
                 [maxlength]="lim.severidadEtiqueta" placeholder="Ej. Moderado">
        </label>
        <label class="corta">
          <span>Estatus</span>
          <select class="ha-in" [(ngModel)]="borrador.estatus">
            <option value="ACTIVO">ACTIVO</option>
            <option value="INACTIVO">INACTIVO</option>
          </select>
        </label>
        <label class="ancha">
          <span>Criterio</span>
          <textarea class="ha-in" rows="2" [(ngModel)]="borrador.descripcion"
                    [maxlength]="lim.severidadDescripcion"
                    placeholder="Cuándo aplica este nivel"></textarea>
        </label>
      </div>
      <div class="ha-alta-pie">
        <button type="button" class="ha-btn-ok" (click)="guardar()" [disabled]="guardando">Guardar</button>
        <button type="button" class="ha-btn-no" (click)="cancelar()" [disabled]="guardando">Cancelar</button>
      </div>
    </div>

    <div class="ha-tarjeta ha-alta" *ngIf="editandoTipo('CLAS_SEVERIDAD')">
      <div class="ha-alta-tit">
        {{ esAlta() ? 'Nueva banda de severidad' : 'Editando la banda' }}
      </div>
      <div class="ha-alta-grid">
        <label class="corta">
          <span>Clasificación *</span>
          <input type="text" class="ha-in" [(ngModel)]="borrador.clasificacion"
                 [maxlength]="lim.clasificacion" placeholder="Ej. Media">
        </label>
        <label class="corta">
          <span>Desde (1 a 16) *</span>
          <input type="number" class="ha-in mini" min="1" max="16" [(ngModel)]="borrador.nivelDesde">
        </label>
        <label class="corta">
          <span>Hasta (1 a 16) *</span>
          <input type="number" class="ha-in mini" min="1" max="16" [(ngModel)]="borrador.nivelHasta">
        </label>
        <label class="ancha">
          <span>Criterio de aceptación</span>
          <textarea class="ha-in" rows="3" [(ngModel)]="borrador.criterioAceptacion"
                    [maxlength]="lim.criterio"></textarea>
        </label>
      </div>
      <div class="ha-alta-pie">
        <button type="button" class="ha-btn-ok" (click)="guardar()" [disabled]="guardando">Guardar</button>
        <button type="button" class="ha-btn-no" (click)="cancelar()" [disabled]="guardando">Cancelar</button>
      </div>
    </div>

    <!-- Las tres tarjetas, en el orden del formato -->
    <div class="cri-cols" [class.editando]="modoEdicion">

      <ng-container *ngTemplateOutlet="cajaCriterio; context: { titulo: 'Probabilidad', aplica: 'PROBABILIDAD' }"></ng-container>

      <ng-container *ngTemplateOutlet="cajaCriterio; context: { titulo: 'Impacto', aplica: 'IMPACTO' }"></ng-container>

      <div class="cri-caja">
        <div class="cri-tit">Severidad del riesgo y criterio de aceptación</div>
        <table class="cri-tabla">
          <thead>
            <tr>
              <th>Severidad</th>
              <th class="n">Probabilidad &times; impacto</th>
              <th>Criterio de aceptación</th>
              <th class="cri-acc-th" *ngIf="modoEdicion">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let c of clasSeveridad; trackBy: rastreaPorId"
                [ngClass]="claseFila(c.clasificacion)"
                [class.en-edicion]="editando('CLAS_SEVERIDAD', c.idCatClasSev)">
              <td class="banda">{{ c.clasificacion }}</td>
              <td class="n">{{ rangoBanda(c) }}</td>
              <td class="criterio">{{ c.criterioAceptacion || '—' }}</td>
              <td class="cri-acc-td" *ngIf="modoEdicion">
                <button type="button" class="ha-btn-edit" (click)="editar('CLAS_SEVERIDAD', c)"
                        [disabled]="bloqueado('CLAS_SEVERIDAD', c.idCatClasSev)">Editar</button>
                <button type="button" class="ha-btn-baja"
                        (click)="pedirBaja('CLAS_SEVERIDAD', c, 'Banda ' + c.clasificacion)"
                        [disabled]="bloqueado('CLAS_SEVERIDAD', c.idCatClasSev)">Eliminar</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <p class="ha-explica ha-pie">
      Estos valores salen del catálogo del sistema, que es el mismo con el que se calcula la
      severidad de cada riesgo. Coinciden con el formato FOS-005. Las bandas tienen que cubrir
      del 1 al 16 sin huecos: si una baja dejara una severidad sin cubrir, el sistema no la
      permite y dice cuáles quedarían fuera.
    </p>
  </section>

  <!-- ============================================================
       2. EJEMPLO DE AMENAZAS
       ============================================================ -->
  <section class="ha-hoja" *ngIf="!cargando && pestana === 'amenazas'">

    <div class="ha-tit">
      <h3>Catálogo de amenazas</h3>
      <div class="ha-tit-btns" *ngIf="modoEdicion">
        <button type="button" class="ha-btn-alta"
                (click)="agregar('AMENAZA')" [disabled]="!!edicion">+ Agregar amenaza</button>
        <button type="button" class="ha-btn-alta contorno"
                (click)="abrirAltaCategoria()" [disabled]="!!edicion">+ Nueva categoría</button>
      </div>
    </div>
    <p class="ha-explica">
      Sirve para clasificar cada amenaza propia dentro de una categoría reconocida. Se elige
      en la edición del activo, en el campo <em>Categoría del catálogo</em>. La categoría se
      escribe tal cual: las que ya existen se agrupan solas.
    </p>

    <!-- Categoría nueva con sus amenazas, capturadas de una vez. -->
    <div class="ha-tarjeta ha-alta" *ngIf="altaCategoria">
      <div class="ha-alta-tit">Nueva categoría con sus amenazas</div>
      <div class="ha-alta-grid">
        <label>
          <span>Nombre de la categoría *</span>
          <input type="text" class="ha-in" [(ngModel)]="borrador.categoria"
                 [maxlength]="lim.amenazaCategoria" [disabled]="guardando"
                 placeholder="Ej. AMENAZAS DE IA GENERATIVA">
        </label>
      </div>

      <div class="ha-cat-lista">
        <span class="ha-cat-et">Amenazas de la categoría</span>
        <div class="ha-cat-ren"
             *ngFor="let n of borrador.nombres; let i = index; trackBy: rastreaIndice">
          <input [attr.aria-label]="'Amenaza ' + (i + 1) + (i === 0 ? ' *' : '')" type="text" class="ha-in" [(ngModel)]="borrador.nombres[i]"
                 [maxlength]="lim.amenazaNombre" [disabled]="guardando"
                 [placeholder]="'Amenaza ' + (i + 1) + (i === 0 ? ' *' : '')">
          <button type="button" class="ha-btn-no chico" (click)="quitarRenglonCategoria(i)"
                  [disabled]="borrador.nombres.length === 1 || guardando"
                  title="Quitar este renglón">✕</button>
        </div>
        <button type="button" class="ha-btn-mini" (click)="agregarRenglonCategoria()"
                [disabled]="guardando">+ Otra amenaza</button>
      </div>

      <div class="ha-alta-pie">
        <button type="button" class="ha-btn-ok" (click)="guardarCategoriaNueva()"
                [disabled]="guardando">{{ guardando ? 'Guardando…' : 'Guardar categoría' }}</button>
        <button type="button" class="ha-btn-no" (click)="cancelar()" [disabled]="guardando">Cancelar</button>
      </div>
      <p class="ha-cat-nota">
        Los renglones vacíos se ignoran. Si el nombre coincide con una categoría que ya
        existe, las amenazas se agregan a ella.
      </p>
    </div>

    <div class="ha-tarjeta ha-alta" *ngIf="editando('AMENAZA', null) && !altaCategoria">
      <div class="ha-alta-grid">
        <label>
          <span>Categoría *</span>
          <input type="text" class="ha-in" [(ngModel)]="borrador.categoria"
                 [maxlength]="lim.amenazaCategoria" list="categoriasExistentes"
                 placeholder="Ej. ATAQUES INTENCIONADOS">
          <datalist id="categoriasExistentes">
            <option *ngFor="let c of categoriasAmenaza()" [value]="c"></option>
          </datalist>
        </label>
        <label>
          <span>Amenaza *</span>
          <input type="text" class="ha-in" [(ngModel)]="borrador.nombre"
                 [maxlength]="lim.amenazaNombre" placeholder="Ej. Ingeniería social">
        </label>
        <label class="corta">
          <span>Orden</span>
          <input type="number" class="ha-in mini" [(ngModel)]="borrador.orden">
        </label>
        <label class="corta">
          <span>Estatus</span>
          <select class="ha-in" [(ngModel)]="borrador.estatus">
            <option value="ACTIVO">ACTIVO</option>
            <option value="INACTIVO">INACTIVO</option>
          </select>
        </label>
      </div>
      <div class="ha-alta-pie">
        <button type="button" class="ha-btn-ok" (click)="guardar()" [disabled]="guardando">Guardar</button>
        <button type="button" class="ha-btn-no" (click)="cancelar()" [disabled]="guardando">Cancelar</button>
      </div>
    </div>

    <!-- Una sub-pestaña por categoría: apiladas eran un muro de 54 renglones. -->
    <div class="ha-subnav" *ngIf="categoriasAmenaza().length">
      <button type="button" *ngFor="let cat of categoriasAmenaza()" class="ha-subtab"
              [ngClass]="claseCategoria(cat)"
              [class.activa]="categoriaActiva === cat" (click)="elegirCategoria(cat)">
        {{ cat }}
        <span class="ha-subtab-n">{{ amenazasDe(cat).length }}</span>
      </button>
    </div>

    <ng-container *ngIf="categoriaActiva && amenazasDe(categoriaActiva) as lista">
      <p class="ha-cat-desc" *ngIf="descripcionCategoria(categoriaActiva)">
        {{ descripcionCategoria(categoriaActiva) }}
      </p>
      <div class="ha-tarjeta">
        <table class="ha-tabla">
          <thead>
            <tr>
              <th class="w-mini">Orden</th>
              <th>Amenaza</th>
              <th class="w-corta c">Estatus</th>
              <th class="w-acciones" *ngIf="modoEdicion">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let a of rebanada(lista, 'amz'); trackBy: rastreaPorId"
                [class.en-edicion]="editando('AMENAZA', a.idCatAmenaza)"
                [class.apagado]="!activo(a)">

              <ng-container *ngIf="!editando('AMENAZA', a.idCatAmenaza)">
                <td class="c">{{ a.orden }}</td>
                <td>{{ a.nombre }}</td>
                <td class="c"><span class="chip" [ngClass]="activo(a) ? 'chip-on' : 'chip-off'">{{ a.estatus }}</span></td>
                <td class="c nw" *ngIf="modoEdicion">
                  <button type="button" class="ha-btn-edit" (click)="editar('AMENAZA', a)"
                          [disabled]="bloqueado('AMENAZA', a.idCatAmenaza)">Editar</button>
                  <button type="button" class="ha-btn-estatus" (click)="alternarEstatus('AMENAZA', a)"
                          [disabled]="bloqueado('AMENAZA', a.idCatAmenaza) || guardando">
                    {{ activo(a) ? 'Desactivar' : 'Activar' }}</button>
                  <button type="button" class="ha-btn-baja"
                          (click)="pedirBaja('AMENAZA', a, a.nombre || '')"
                          [disabled]="bloqueado('AMENAZA', a.idCatAmenaza)">Eliminar</button>
                </td>
              </ng-container>

              <ng-container *ngIf="editando('AMENAZA', a.idCatAmenaza)">
                <td><input aria-label="Orden" type="number" class="ha-in mini" [(ngModel)]="borrador.orden"></td>
                <td>
                  <input aria-label="Categoría *" type="text" class="ha-in" [(ngModel)]="borrador.categoria"
                         [maxlength]="lim.amenazaCategoria" placeholder="Categoría *">
                  <input aria-label="Amenaza *" type="text" class="ha-in" [(ngModel)]="borrador.nombre"
                         [maxlength]="lim.amenazaNombre" placeholder="Amenaza *">
                </td>
                <td>
                  <select aria-label="Estatus" class="ha-in" [(ngModel)]="borrador.estatus">
                    <option value="ACTIVO">ACTIVO</option>
                    <option value="INACTIVO">INACTIVO</option>
                  </select>
                </td>
                <td class="c nw">
                  <button type="button" class="ha-btn-ok" (click)="guardar()" [disabled]="guardando">Guardar</button>
                  <button type="button" class="ha-btn-no" (click)="cancelar()" [disabled]="guardando">Cancelar</button>
                </td>
              </ng-container>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Paginado: sólo aparece cuando la categoría pasa de 10. Se apaga
           mientras hay un renglón en edición, para no dejarlo fuera de vista. -->
      <div class="ha-pag" *ngIf="lista.length > porPagina">
        <button type="button" class="ha-pag-btn" [disabled]="pagina('amz', lista.length) === 1 || !!edicion"
                (click)="irPagina('amz', pagina('amz', lista.length) - 1, lista.length)">&lsaquo; Anterior</button>
        <button type="button" class="ha-pag-num" *ngFor="let p of numerosPagina(lista.length)"
                [class.activa]="p === pagina('amz', lista.length)" [disabled]="!!edicion"
                (click)="irPagina('amz', p, lista.length)">{{ p }}</button>
        <button type="button" class="ha-pag-btn"
                [disabled]="pagina('amz', lista.length) === totalPaginas(lista.length) || !!edicion"
                (click)="irPagina('amz', pagina('amz', lista.length) + 1, lista.length)">Siguiente &rsaquo;</button>
        <span class="ha-pag-info">
          Página {{ pagina('amz', lista.length) }} de {{ totalPaginas(lista.length) }} &middot; {{ lista.length }} amenazas
        </span>
      </div>
    </ng-container>

    <p class="vacio" *ngIf="amenazas.length === 0">Todavía no hay amenazas en el catálogo.</p>
  </section>

  <!-- ============================================================
       3. APRECIACIÓN DE RIESGOS
       ============================================================ -->
  <section class="ha-hoja" *ngIf="!cargando && pestana === 'apreciacion'">
    <!-- Las cuatro secciones de la hoja del Excel, como páginas. -->
    <div class="exl-subnav">
      <button type="button" *ngFor="let s of seccionesApre" class="exl-subtab"
              [class.activa]="seccionApre === s.clave"
              (click)="elegirSeccionApre(s.clave)">{{ s.titulo }}</button>
    </div>

    <ng-container *ngIf="seccionApre === 'valoracion'">

    <!-- ==========================================================
         Cabecera de la hoja del Excel: que puede ser un activo y
         como se clasifica. Contenido fijo del formato.
         ========================================================== -->
    <div class="exl-intro">
      <div class="ha-tarjeta exl-caja">
        <ng-container *ngTemplateOutlet="cabeceraApoyo; context: { lista: 'TIT_APRE_ACTIVOS', respaldo: 'Los activos pueden ser' }"></ng-container>
        <ul class="exl-lista">
          <li *ngFor="let a of apoyoDe('ACTIVOS_PUEDEN_SER'); trackBy: rastreaPorId"
              [class.apagado]="!activo(a)"
              [class.en-edicion]="a.idApoyoLista && editando('APOYO_LISTA', a.idApoyoLista)">
            <ng-container *ngTemplateOutlet="renglonApoyo; context: { $implicit: a }"></ng-container>
          </li>
        </ul>
        <div class="exl-alta" *ngIf="modoEdicion">
            <ng-container *ngTemplateOutlet="altaApoyo; context: { $implicit: 'ACTIVOS_PUEDEN_SER' }"></ng-container>
          </div>
      </div>
      <div class="ha-tarjeta exl-caja">
        <ng-container *ngTemplateOutlet="cabeceraApoyo; context: { lista: 'TIT_APRE_CLASIF', respaldo: 'Clasificación de Activos' }"></ng-container>
        <div class="exl-clasif">
          <ng-container *ngTemplateOutlet="columnaClasificacion; context: { titulo: 'Hardware', lista: 'CLASIF_HARDWARE' }"></ng-container>
          <ng-container *ngTemplateOutlet="columnaClasificacion; context: { titulo: 'Software', lista: 'CLASIF_SOFTWARE' }"></ng-container>
        </div>
      </div>
    </div>

    <ng-container *ngTemplateOutlet="cabeceraApoyo; context: { lista: 'TIT_APRE_VAL', respaldo: 'Valoración de Activos', titulo: true }"></ng-container>

    <!-- Como el Excel: cabecera, definición y contenido, sin título repetido.
         El botón vive en una barrita aparte para no inventarle renglones a la
         hoja. -->
    <div class="exl-toolbar" *ngIf="modoEdicion">
      <button type="button" class="ha-btn-alta"
              (click)="agregar('VALORACION')" [disabled]="!!edicion">+ Agregar criterio de valoración</button>
    </div>

    <div class="ha-tarjeta ha-alta" *ngIf="editando('VALORACION', null)">
      <div class="ha-alta-grid">
        <label class="corta">
          <span>Dimensión *</span>
          <select class="ha-in" [(ngModel)]="borrador.dimension">
            <option *ngFor="let d of DIMENSIONES" [value]="d">{{ d | titlecase }}</option>
          </select>
        </label>
        <label class="corta">
          <span>Nivel (1 a 5) *</span>
          <input type="number" class="ha-in mini" min="1" max="5" [(ngModel)]="borrador.nivel">
        </label>
        <label>
          <span>Etiqueta *</span>
          <input type="text" class="ha-in" [(ngModel)]="borrador.etiqueta"
                 [maxlength]="lim.valoracionEtiqueta">
        </label>
        <label class="ancha">
          <span>Criterio</span>
          <textarea class="ha-in" rows="3" [(ngModel)]="borrador.descripcion"
                    [maxlength]="lim.valoracionDescripcion"></textarea>
        </label>
      </div>
      <div class="ha-alta-pie">
        <button type="button" class="ha-btn-ok" (click)="guardar()" [disabled]="guardando">Guardar</button>
        <button type="button" class="ha-btn-no" (click)="cancelar()" [disabled]="guardando">Cancelar</button>
      </div>
    </div>

    <!-- Una sub-pestaña por dimensión, igual que las categorías de amenazas. -->
    <div class="ha-subnav">
      <button type="button" *ngFor="let d of DIMENSIONES" class="ha-subtab"
              [class.activa]="dimensionActiva === d" (click)="elegirDimension(d)">
        {{ d | titlecase }}
        <span class="ha-subtab-n">{{ valoracionPor(d).length }}</span>
      </button>
    </div>

    <ng-container *ngIf="valoracionPor(dimensionActiva) as lista">
      <ng-container *ngTemplateOutlet="definicionApoyo; context: { lista: listaDimension(dimensionActiva), respaldo: definicionDimension(dimensionActiva) }"></ng-container>
      <div class="ha-tarjeta">
        <table class="ha-tabla">
          <thead>
            <tr>
              <th class="w-mini">Nivel</th>
              <th class="w-media">Etiqueta</th>
              <th>Criterio</th>
              <th class="w-corta c">Estatus</th>
              <th class="w-acciones" *ngIf="modoEdicion">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let v of rebanada(lista, 'val'); trackBy: rastreaPorId"
                [class.en-edicion]="editando('VALORACION', v.idCatValoracion)"
                [class.apagado]="!activo(v)">

              <ng-container *ngIf="!editando('VALORACION', v.idCatValoracion)">
                <td class="c"><strong>{{ v.nivel }}</strong></td>
                <td>{{ v.etiqueta }}</td>
                <td class="td-largo">{{ v.descripcion || '—' }}</td>
                <td class="c"><span class="chip" [ngClass]="activo(v) ? 'chip-on' : 'chip-off'">{{ v.estatus }}</span></td>
                <td class="c nw" *ngIf="modoEdicion">
                  <button type="button" class="ha-btn-edit" (click)="editar('VALORACION', v)"
                          [disabled]="bloqueado('VALORACION', v.idCatValoracion)">Editar</button>
                  <button type="button" class="ha-btn-estatus" (click)="alternarEstatus('VALORACION', v)"
                          [disabled]="bloqueado('VALORACION', v.idCatValoracion) || guardando">
                    {{ activo(v) ? 'Desactivar' : 'Activar' }}</button>
                  <button type="button" class="ha-btn-baja"
                          (click)="pedirBaja('VALORACION', v, dimensionActiva + ' nivel ' + v.nivel)"
                          [disabled]="bloqueado('VALORACION', v.idCatValoracion)">Eliminar</button>
                </td>
              </ng-container>

              <ng-container *ngIf="editando('VALORACION', v.idCatValoracion)">
                <td><input aria-label="Nivel" type="number" class="ha-in mini" min="1" max="5" [(ngModel)]="borrador.nivel"></td>
                <td><input aria-label="Etiqueta" type="text" class="ha-in" [(ngModel)]="borrador.etiqueta"
                           [maxlength]="lim.valoracionEtiqueta"></td>
                <td><textarea aria-label="Criterio" class="ha-in" rows="3" [(ngModel)]="borrador.descripcion"
                              [maxlength]="lim.valoracionDescripcion"></textarea></td>
                <td>
                  <select aria-label="Estatus" class="ha-in" [(ngModel)]="borrador.estatus">
                    <option value="ACTIVO">ACTIVO</option>
                    <option value="INACTIVO">INACTIVO</option>
                  </select>
                </td>
                <td class="c nw">
                  <button type="button" class="ha-btn-ok" (click)="guardar()" [disabled]="guardando">Guardar</button>
                  <button type="button" class="ha-btn-no" (click)="cancelar()" [disabled]="guardando">Cancelar</button>
                </td>
              </ng-container>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="ha-pag" *ngIf="lista.length > porPagina">
        <button type="button" class="ha-pag-btn" [disabled]="pagina('val', lista.length) === 1 || !!edicion"
                (click)="irPagina('val', pagina('val', lista.length) - 1, lista.length)">&lsaquo; Anterior</button>
        <button type="button" class="ha-pag-num" *ngFor="let p of numerosPagina(lista.length)"
                [class.activa]="p === pagina('val', lista.length)" [disabled]="!!edicion"
                (click)="irPagina('val', p, lista.length)">{{ p }}</button>
        <button type="button" class="ha-pag-btn"
                [disabled]="pagina('val', lista.length) === totalPaginas(lista.length) || !!edicion"
                (click)="irPagina('val', pagina('val', lista.length) + 1, lista.length)">Siguiente &rsaquo;</button>
        <span class="ha-pag-info">
          Página {{ pagina('val', lista.length) }} de {{ totalPaginas(lista.length) }} &middot; {{ lista.length }} criterios
        </span>
      </div>
    </ng-container>
    </ng-container>

    <ng-container *ngIf="seccionApre === 'valoracion'">
    <!-- ==========================================================
         Identificacion y valoracion de amenazas: cabecera oscura,
         definicion y la escala de ocurrencia, como en el Excel.
         ========================================================== -->
    <ng-container *ngTemplateOutlet="cabeceraApoyo; context: { lista: 'TIT_APRE_AME', respaldo: 'Identificación y valoración de amenazas', titulo: true, sep: true }"></ng-container>
    <ng-container *ngTemplateOutlet="definicionApoyo; context: { lista: 'DEF_APRE_AME', respaldo: 'Amenaza. ' + definicion('nombreAmenaza') }"></ng-container>

    <div class="ha-tit">
      <h3>Probabilidad de ocurrencia</h3>
      <button type="button" class="ha-btn-alta" *ngIf="modoEdicion"
              (click)="agregar('PROBABILIDAD')" [disabled]="!!edicion">+ Agregar criterio</button>
    </div>
    <p class="ha-explica">
      Niveles del 1 al 4. El campo <em>aplica a</em> del alta decide si el criterio es de la
      escala de amenazas o de la de vulnerabilidades.
    </p>
    <div class="ha-tarjeta ha-alta" *ngIf="editando('PROBABILIDAD', null) && borrador && borrador.aplicaA !== 'VULNERABILIDAD'">
      <ng-container *ngTemplateOutlet="panelProbabilidad"></ng-container>
    </div>

    <div class="ha-grupo">
      <ng-container *ngTemplateOutlet="definicionApoyo; context: { lista: 'DEF_APRE_PROB_AME', respaldo: definicion('probAmenaza'), suave: true }"></ng-container>
      <ng-container *ngTemplateOutlet="tablaProbabilidad; context: { aplica: 'AMENAZA', nombre: 'Amenaza' }"></ng-container>
    </div>
    </ng-container>

    <ng-container *ngIf="seccionApre === 'valoracion'">
    <!-- ==========================================================
         Vulnerabilidades: la tercera cabecera de la hoja.
         ========================================================== -->
    <ng-container *ngTemplateOutlet="cabeceraApoyo; context: { lista: 'TIT_APRE_VUL', respaldo: 'Determinación de las vulnerabilidades del sistema y su relación con las amenazas', titulo: true, sep: true }"></ng-container>
    <ng-container *ngTemplateOutlet="definicionApoyo; context: { lista: 'DEF_APRE_VUL', respaldo: definicion('vulnerabilidad') }"></ng-container>

    <div class="exl-toolbar" *ngIf="modoEdicion">
      <button type="button" class="ha-btn-alta"
              (click)="agregarProbabilidadPara('VULNERABILIDAD')" [disabled]="!!edicion">+ Agregar criterio</button>
    </div>

    <div class="ha-tarjeta ha-alta" *ngIf="editando('PROBABILIDAD', null) && borrador && borrador.aplicaA === 'VULNERABILIDAD'">
      <ng-container *ngTemplateOutlet="panelProbabilidad"></ng-container>
    </div>



    <div class="ha-grupo">
      <ng-container *ngTemplateOutlet="definicionApoyo; context: { lista: 'DEF_APRE_PROB_VUL', respaldo: definicion('probVulnerabilidad'), suave: true }"></ng-container>
      <ng-container *ngTemplateOutlet="tablaProbabilidad; context: { aplica: 'VULNERABILIDAD', nombre: 'Vulnerabilidad' }"></ng-container>
    </div>

    <!-- 3.3 Bandas de clasificación del riesgo -->
    </ng-container>

    <ng-container *ngIf="seccionApre === 'riesgo'">
    <ng-container *ngTemplateOutlet="cabeceraApoyo; context: { lista: 'TIT_APRE_RIESGO', respaldo: 'Valoración del Riesgo — riesgo actual (intrínseco) / riesgo tras plan de acción (residual)', titulo: true, sep: true }"></ng-container>
    <p class="ha-explica">
      Es el corazón del cálculo: <strong>valor del activo &times; amenaza &times;
      vulnerabilidad</strong> da el nivel de riesgo de 0 a 11. Las 96 combinaciones deben
      existir todas, por eso aquí sólo se <strong>corrige</strong> el nivel de una celda:
      no se agregan ni se borran filas. Si faltara una, el activo que cayera en ese cruce se
      quedaría sin riesgo calculado.
      <span *ngIf="modoEdicion"><br><strong>Toque un número para corregirlo.</strong></span>
    </p>

    <div class="ha-tarjeta ha-scroll">
      <table class="ha-tabla ha-96">
        <thead>
          <tr>
            <th class="w-mini">Valor activo</th>
            <th class="w-mini">Amenaza</th>
            <th *ngFor="let vu of NIVELES_14" class="c">Vulnerabilidad {{ vu }}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let va of VALORES">
            <tr *ngFor="let am of NIVELES_14">
              <td class="c"><strong>{{ va }}</strong></td>
              <td class="c">{{ am }}</td>
              <td *ngFor="let vu of NIVELES_14" class="c celda-96">
                <ng-container *ngIf="celda(va, am, vu) as n">
                  <span *ngIf="!editando('NIVEL_RIESGO', n.idCatNivelRiesgo)"
                        class="chip" [ngClass]="claseNivel(n.nivelRiesgo)"
                        [class.clic]="modoEdicion && !edicion"
                        (click)="modoEdicion && !edicion ? editar('NIVEL_RIESGO', n) : null"
                        (keydown.enter)="modoEdicion && !edicion ? editar('NIVEL_RIESGO', n) : null">{{ n.nivelRiesgo }}</span>

                  <span *ngIf="editando('NIVEL_RIESGO', n.idCatNivelRiesgo)" class="nw">
                    <input aria-label="Nivel de riesgo" type="number" class="ha-in mini" min="0" max="11" [(ngModel)]="borrador.nivelRiesgo">
                    <button type="button" class="ha-btn-ok chico" (click)="guardar()" [disabled]="guardando">✓</button>
                    <button type="button" class="ha-btn-no chico" (click)="cancelar()" [disabled]="guardando">✕</button>
                  </span>
                </ng-container>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
    <p class="ha-explica ha-pie">
      El color sale de las bandas de clasificación de arriba, así que si cambia una banda,
      esta tabla se recolorea sola.
    </p>
    <ng-container *ngTemplateOutlet="cabeceraApoyo; context: { lista: 'TIT_APRE_CRIT', respaldo: 'Criterio de aceptación del riesgo', titulo: true, sep: true }"></ng-container>
    <div class="ha-tit">
      <h3>Bandas de clasificación y criterio de aceptación</h3>
      <button type="button" class="ha-btn-alta" *ngIf="modoEdicion"
              (click)="agregar('CLASIFICACION')" [disabled]="!!edicion">+ Agregar banda</button>
    </div>
    <p class="ha-explica">
      Las bandas tienen que cubrir <strong>del 1 al 11 sin huecos</strong>: contra ellas se
      resuelve la clasificación y la periodicidad de monitoreo de cada activo. Si una baja
      dejara un nivel sin cubrir, el sistema no la permite y dice cuáles quedarían fuera.
    </p>

    <div class="ha-tarjeta ha-alta" *ngIf="editando('CLASIFICACION', null)">
      <div class="ha-alta-grid">
        <label class="corta">
          <span>Desde (1 a 11) *</span>
          <input type="number" class="ha-in mini" min="1" max="11" [(ngModel)]="borrador.nivelDesde">
        </label>
        <label class="corta">
          <span>Hasta (1 a 11) *</span>
          <input type="number" class="ha-in mini" min="1" max="11" [(ngModel)]="borrador.nivelHasta">
        </label>
        <label class="corta">
          <span>Clasificación *</span>
          <input type="text" class="ha-in" [(ngModel)]="borrador.clasificacion"
                 [maxlength]="lim.clasificacion">
        </label>
        <label class="corta">
          <span>Periodicidad máxima *</span>
          <input type="text" class="ha-in" [(ngModel)]="borrador.periodicidadMaxima"
                 [maxlength]="lim.periodicidad">
        </label>
        <label class="ancha">
          <span>Criterio de aceptación</span>
          <textarea class="ha-in" rows="3" [(ngModel)]="borrador.criterioAceptacion"
                    [maxlength]="lim.criterio"></textarea>
        </label>
      </div>
      <div class="ha-alta-pie">
        <button type="button" class="ha-btn-ok" (click)="guardar()" [disabled]="guardando">Guardar</button>
        <button type="button" class="ha-btn-no" (click)="cancelar()" [disabled]="guardando">Cancelar</button>
      </div>
    </div>

    <div class="ha-tarjeta">
      <table class="ha-tabla">
        <thead>
          <tr>
            <th class="w-mini">Rango</th>
            <th class="w-corta c">Clasificación</th>
            <th class="w-corta">Periodicidad</th>
            <th>Criterio de aceptación</th>
            <th class="w-acciones" *ngIf="modoEdicion">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of clasificaciones; trackBy: rastreaPorId"
              [class.en-edicion]="editando('CLASIFICACION', c.idCatClasificacion)">

            <ng-container *ngIf="!editando('CLASIFICACION', c.idCatClasificacion)">
              <td class="c nw">{{ c.nivelDesde }} a {{ c.nivelHasta }}</td>
              <td class="c"><span class="chip" [ngClass]="claseBanda(c.clasificacion)">{{ c.clasificacion }}</span></td>
              <td class="c">{{ c.periodicidadMaxima }}</td>
              <td class="td-largo td-pre">{{ c.criterioAceptacion || '—' }}</td>
              <td class="c nw" *ngIf="modoEdicion">
                <button type="button" class="ha-btn-edit" (click)="editar('CLASIFICACION', c)"
                        [disabled]="bloqueado('CLASIFICACION', c.idCatClasificacion)">Editar</button>
                <button type="button" class="ha-btn-baja"
                        (click)="pedirBaja('CLASIFICACION', c, 'Banda ' + c.clasificacion)"
                        [disabled]="bloqueado('CLASIFICACION', c.idCatClasificacion)">Eliminar</button>
              </td>
            </ng-container>

            <ng-container *ngIf="editando('CLASIFICACION', c.idCatClasificacion)">
              <td class="nw">
                <input aria-label="Desde (1 a 11)" type="number" class="ha-in mini" min="1" max="11" [(ngModel)]="borrador.nivelDesde">
                <input aria-label="Hasta (1 a 11)" type="number" class="ha-in mini" min="1" max="11" [(ngModel)]="borrador.nivelHasta">
              </td>
              <td><input aria-label="Clasificación" type="text" class="ha-in" [(ngModel)]="borrador.clasificacion"
                         [maxlength]="lim.clasificacion"></td>
              <td><input aria-label="Periodicidad" type="text" class="ha-in" [(ngModel)]="borrador.periodicidadMaxima"
                         [maxlength]="lim.periodicidad"></td>
              <td><textarea aria-label="Criterio de aceptación" class="ha-in" rows="3" [(ngModel)]="borrador.criterioAceptacion"
                            [maxlength]="lim.criterio"></textarea></td>
              <td class="c nw">
                <button type="button" class="ha-btn-ok" (click)="guardar()" [disabled]="guardando">Guardar</button>
                <button type="button" class="ha-btn-no" (click)="cancelar()" [disabled]="guardando">Cancelar</button>
              </td>
            </ng-container>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 3.4 Tabla de valoración del riesgo (las 96 combinaciones) -->
    </ng-container>


  </section>

  <!-- ============================================================
       4. CRITERIOS DE EVALUACIÓN (Plan de Gestión)

       Mismo acomodo y mismos colores que la ventana de Criterios del Plan de
       Gestión: probabilidad e impacto en dos tarjetas angostas y la severidad
       en una ancha, porque lleva el criterio completo. Se editan aquí, pero se
       ven exactamente igual que allá, que es donde se consultan.

       La captura NO va dentro de la tarjeta: en 190px no cabe un criterio de
       tres renglones. Se hace en el panel de arriba, y mientras tanto el
       renglón que se está tocando queda marcado en la tarjeta.
       ============================================================ -->
  <!-- ============================================================
       Confirmación de baja
       ============================================================ -->
  <div class="ha-conf" *ngIf="confirma">
    <div class="ha-conf-fondo" (click)="confirmarNo()" (keydown.enter)="confirmarNo()"></div>
    <div class="ha-conf-caja" role="dialog" aria-modal="true">
      <h4>{{ confirma.titulo }}</h4>
      <p class="ha-conf-que">{{ confirma.texto }}</p>
      <p class="ha-conf-det" *ngIf="confirma.detalle">{{ confirma.detalle }}</p>
      <div class="ha-conf-pie">
        <button type="button" class="ha-btn-no" (click)="confirmarNo()">No, cancelar</button>
        <button type="button" class="ha-btn-baja solido" (click)="confirmarSi()">Sí, eliminar</button>
      </div>
    </div>
  </div>

</div>

<!-- ============================================================
     Piezas que se repetían en las hojas: se definen una sola vez
     y se pintan donde hacen falta con ngTemplateOutlet, con los
     mismos elementos, clases y textos que tenía cada copia.
     ============================================================ -->

<!-- Cabecera oscura editable de una sección: un renglón TIT_* de las hojas de apoyo. -->
<ng-template #cabeceraApoyo let-lista="lista" let-respaldo="respaldo" let-titulo="titulo" let-sep="sep">
    <div class="exl-cab exl-cab-flex" [class.exl-titulo]="titulo" [class.exl-sep]="sep"
         [class.apagado-cab]="!apoyoActivo(lista)"
         [class.en-edicion]="editandoFila(introFila(lista))">
      <ng-container *ngIf="!editandoFila(introFila(lista))">
        <span class="exl-cab-txt">{{ apoyoTextoDe(lista, respaldo) }}</span>
        <span class="est-acc" *ngIf="modoEdicion && introFila(lista)">
          <button type="button" class="est-btn" (click)="editar('APOYO_LISTA', introFila(lista))"
                  [disabled]="!!edicion">Editar</button>
          <button type="button" class="est-btn" (click)="alternarEstatus('APOYO_LISTA', introFila(lista))"
                  [disabled]="!!edicion || guardando">{{ apoyoActivo(lista) ? 'Desactivar' : 'Activar' }}</button>
        </span>
      </ng-container>
      <ng-container *ngIf="editandoFila(introFila(lista))">
        <input aria-label="Título" type="text" class="ha-in exl-in" [(ngModel)]="borrador.texto"
               [maxlength]="lim.apoyoTexto" [disabled]="guardando">
        <button type="button" class="ha-btn-ok chico" (click)="guardar()" [disabled]="guardando">&#10003;</button>
        <button type="button" class="ha-btn-no chico" (click)="cancelar()" [disabled]="guardando">&#10005;</button>
      </ng-container>
    </div>
</ng-template>

<!-- Definición editable bajo una cabecera: un renglón DEF_* de las hojas de apoyo. -->
<ng-template #definicionApoyo let-lista="lista" let-respaldo="respaldo" let-suave="suave">
    <div class="exl-def" [class.suave]="suave" [class.apagado-cab]="!apoyoActivo(lista)"
      *ngIf="!editandoFila(introFila(lista))">{{ apoyoTextoDe(lista, respaldo) }}
      <div class="cri3-def-acc" *ngIf="modoEdicion && introFila(lista)">
        <button type="button" class="est-btn" (click)="editar('APOYO_LISTA', introFila(lista))"
                [disabled]="!!edicion">Editar</button>
        <button type="button" class="est-btn" (click)="alternarEstatus('APOYO_LISTA', introFila(lista))"
                [disabled]="!!edicion || guardando">{{ apoyoActivo(lista) ? 'Desactivar' : 'Activar' }}</button>
      </div>
    </div>
    <div class="est-edit" *ngIf="editandoFila(introFila(lista))">
      <textarea aria-label="Definición" class="ha-in" rows="4" [(ngModel)]="borrador.texto"
                [maxlength]="lim.introCuerpo" [disabled]="guardando"></textarea>
      <div class="ha-alta-pie">
        <button type="button" class="ha-btn-ok" (click)="guardar()" [disabled]="guardando">Guardar</button>
        <button type="button" class="ha-btn-no" (click)="cancelar()" [disabled]="guardando">Cancelar</button>
      </div>
    </div>
</ng-template>

<!-- Alta o cambio de un nivel de probabilidad o impacto (hoja Estrategias, Criterios de evaluación). -->
<ng-template #panelSeveridad>
      <div class="ha-alta-tit">{{ esAlta() ? 'Nuevo criterio' : 'Editando el criterio' }}</div>
      <div class="ha-alta-grid">
        <label class="corta">
          <span>Aplica a *</span>
          <select class="ha-in" [(ngModel)]="borrador.aplicaA" [disabled]="guardando">
            <option *ngFor="let a of APLICA_SEV" [value]="a">{{ a | titlecase }}</option>
          </select>
        </label>
        <label class="corta">
          <span>Nivel (1 a 4) *</span>
          <input type="number" class="ha-in mini" min="1" max="4" [(ngModel)]="borrador.nivel" [disabled]="guardando">
        </label>
        <label>
          <span>Etiqueta *</span>
          <input type="text" class="ha-in" [(ngModel)]="borrador.etiqueta"
                 [maxlength]="lim.severidadEtiqueta" [disabled]="guardando">
        </label>
        <label class="corta">
          <span>Estatus</span>
          <select class="ha-in" [(ngModel)]="borrador.estatus" [disabled]="guardando">
            <option value="ACTIVO">ACTIVO</option>
            <option value="INACTIVO">INACTIVO</option>
          </select>
        </label>
        <label class="ancha" *ngIf="borrador.aplicaA === 'IMPACTO'">
          <span>Propósito / dirección estratégica / objetivos</span>
          <textarea class="ha-in" rows="2" [(ngModel)]="borrador.proposito"
                    [maxlength]="lim.severidadDescripcion" [disabled]="guardando"></textarea>
        </label>
        <label class="ancha">
          <span>{{ borrador.aplicaA === 'IMPACTO' ? 'Partes interesadas' : 'Descripción' }}</span>
          <textarea class="ha-in" rows="6" [(ngModel)]="borrador.descripcion"
                    [maxlength]="lim.severidadDescripcion" [disabled]="guardando"></textarea>
        </label>
      </div>
      <div class="ha-alta-pie">
        <button type="button" class="ha-btn-ok" (click)="guardar()" [disabled]="guardando">Guardar</button>
        <button type="button" class="ha-btn-no" (click)="cancelar()" [disabled]="guardando">Cancelar</button>
      </div>
</ng-template>

<!-- Un nivel de probabilidad o impacto en la tabla grande, fuera de edición. -->
<ng-template #celdasSeveridad let-s>
              <td class="td-pre">{{ s.descripcion || '—' }}</td>
              <td class="c nw"><strong>{{ s.etiqueta }}</strong></td>
              <td class="c"><strong>{{ s.nivel }}</strong></td>
              <td class="c"><span class="chip" [ngClass]="activo(s) ? 'chip-on' : 'chip-off'">{{ s.estatus }}</span></td>
              <td class="c nw" *ngIf="modoEdicion">
                <button type="button" class="ha-btn-edit" (click)="editar('SEVERIDAD', s)"
                        [disabled]="bloqueado('SEVERIDAD', s.idCatSeveridad)">Editar</button>
                <button type="button" class="ha-btn-estatus" (click)="alternarEstatus('SEVERIDAD', s)"
                        [disabled]="bloqueado('SEVERIDAD', s.idCatSeveridad) || guardando">
                  {{ activo(s) ? 'Desactivar' : 'Activar' }}</button>
                <button type="button" class="ha-btn-baja"
                        (click)="pedirBaja('SEVERIDAD', s, (s.etiqueta || '') + ' nivel ' + s.nivel)"
                        [disabled]="bloqueado('SEVERIDAD', s.idCatSeveridad)">Eliminar</button>
              </td>
</ng-template>

<!-- Las celdas que comparten las dos tablas grandes de criterios mientras un nivel se edita. -->
<ng-template #edicionSeveridad>
              <td><input aria-label="Etiqueta" type="text" class="ha-in" [(ngModel)]="borrador.etiqueta"
                         [maxlength]="lim.severidadEtiqueta"></td>
              <td><input aria-label="Nivel" type="number" class="ha-in mini" min="1" max="4" [(ngModel)]="borrador.nivel"></td>
              <td>
                <select aria-label="Estatus" class="ha-in" [(ngModel)]="borrador.estatus">
                  <option value="ACTIVO">ACTIVO</option>
                  <option value="INACTIVO">INACTIVO</option>
                </select>
              </td>
              <td class="c nw">
                <button type="button" class="ha-btn-ok" (click)="guardar()" [disabled]="guardando">Guardar</button>
                <button type="button" class="ha-btn-no" (click)="cancelar()" [disabled]="guardando">Cancelar</button>
              </td>
</ng-template>

<!-- Una tarjeta del trío de criterios: probabilidad o impacto. -->
<ng-template #cajaTrio let-aplica="aplica" let-lista="lista" let-respaldo="respaldo" let-marcador="marcador">
<div class="cri3-def" [class.apagado-cab]="!apoyoActivo(lista)"
             *ngIf="!editandoFila(introFila(lista))">{{ apoyoTextoDe(lista, respaldo) }}
          <div class="cri3-def-acc" *ngIf="modoEdicion && introFila(lista)">
            <button type="button" class="est-btn" (click)="editar('APOYO_LISTA', introFila(lista))"
                    [disabled]="!!edicion">Editar</button>
            <button type="button" class="est-btn" (click)="alternarEstatus('APOYO_LISTA', introFila(lista))"
                    [disabled]="!!edicion || guardando">{{ apoyoActivo(lista) ? 'Desactivar' : 'Activar' }}</button>
          </div>
        </div>
        <div class="est-edit" *ngIf="editandoFila(introFila(lista))">
          <textarea aria-label="Definición" class="ha-in" rows="7" [(ngModel)]="borrador.texto"
                    [maxlength]="lim.introCuerpo" [disabled]="guardando"></textarea>
          <div class="ha-alta-pie">
            <button type="button" class="ha-btn-ok" (click)="guardar()" [disabled]="guardando">Guardar</button>
            <button type="button" class="ha-btn-no" (click)="cancelar()" [disabled]="guardando">Cancelar</button>
          </div>
        </div>
        <table class="ha-tabla">
          <!-- Encabezado sólo para lectores de pantalla: a la vista lo da la definición de arriba. -->
          <thead class="cdk-visually-hidden">
            <tr>
              <th scope="col">{{ marcador }}</th>
              <th scope="col">Nivel</th>
              <th scope="col" *ngIf="modoEdicion">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let s of severidadPor(aplica); trackBy: rastreaPorId"
                [class.en-edicion]="editando('SEVERIDAD', s.idCatSeveridad)"
                [class.apagado]="!activo(s)">
              <ng-container *ngIf="!(editando('SEVERIDAD', s.idCatSeveridad) && origenEdicion === 'trio')">
                <td>{{ s.etiqueta }}</td>
                <td class="c w-mini"><strong>{{ s.nivel }}</strong></td>
                <td class="c nw" *ngIf="modoEdicion">
                  <button type="button" class="ha-btn-edit" (click)="editarDesde('trio', 'SEVERIDAD', s)"
                          [disabled]="bloqueado('SEVERIDAD', s.idCatSeveridad)">Editar</button>
                  <button type="button" class="ha-btn-estatus" (click)="alternarEstatus('SEVERIDAD', s)"
                          [disabled]="bloqueado('SEVERIDAD', s.idCatSeveridad) || guardando">
                    {{ activo(s) ? 'Desactivar' : 'Activar' }}</button>
                </td>
              </ng-container>
              <ng-container *ngIf="editando('SEVERIDAD', s.idCatSeveridad) && origenEdicion === 'trio'">
                <td><input [attr.aria-label]="marcador" type="text" class="ha-in" [(ngModel)]="borrador.etiqueta"
                           [maxlength]="lim.severidadEtiqueta" [disabled]="guardando"
                           [placeholder]="marcador"></td>
                <td><input aria-label="Nivel" type="number" class="ha-in mini" min="1" max="4"
                           [(ngModel)]="borrador.nivel" [disabled]="guardando"></td>
                <td class="c nw">
                  <button type="button" class="ha-btn-ok chico" (click)="guardar()" [disabled]="guardando">&#10003;</button>
                  <button type="button" class="ha-btn-no chico" (click)="cancelar()" [disabled]="guardando">&#10005;</button>
                </td>
              </ng-container>
            </tr>
          </tbody>
        </table>
</ng-template>

<!-- Probabilidad o impacto en la pestaña Criterios de evaluación, como los muestra el Plan de Gestión. -->
<ng-template #cajaCriterio let-titulo="titulo" let-aplica="aplica">
      <div class="cri-caja">
        <div class="cri-tit">{{ titulo }}</div>
        <table class="cri-tabla">
          <!-- Encabezado sólo para lectores de pantalla: a la vista lo da el título de la caja. -->
          <thead class="cdk-visually-hidden">
            <tr><th scope="col">{{ titulo }}</th></tr>
          </thead>
          <tr *ngFor="let s of severidadPor(aplica); trackBy: rastreaPorId"
              [class.en-edicion]="editando('SEVERIDAD', s.idCatSeveridad)"
              [class.apagado]="!activo(s)">
            <td>
              <div class="cri-fila">
                <span class="cri-et">
                  {{ s.etiqueta }}
                  <span class="cri-off" *ngIf="!activo(s)">inactivo</span>
                </span>
                <span class="n">{{ s.nivel }}</span>
              </div>
              <span class="cri-que" *ngIf="modoEdicion && s.descripcion">{{ s.descripcion }}</span>
              <div class="cri-acc" *ngIf="modoEdicion">
                <button type="button" class="ha-btn-edit" (click)="editar('SEVERIDAD', s)"
                        [disabled]="bloqueado('SEVERIDAD', s.idCatSeveridad)">Editar</button>
                <button type="button" class="ha-btn-estatus" (click)="alternarEstatus('SEVERIDAD', s)"
                        [disabled]="bloqueado('SEVERIDAD', s.idCatSeveridad) || guardando">
                  {{ activo(s) ? 'Desactivar' : 'Activar' }}</button>
                <button type="button" class="ha-btn-baja"
                        (click)="pedirBaja('SEVERIDAD', s, titulo + ' nivel ' + s.nivel)"
                        [disabled]="bloqueado('SEVERIDAD', s.idCatSeveridad)">Eliminar</button>
              </div>
            </td>
          </tr>
        </table>
      </div>
</ng-template>

<!-- Un renglón de las listas de la cabecera de Apreciación, en consulta o en edición. -->
<ng-template #renglonApoyo let-a>
            <ng-container *ngIf="!(a.idApoyoLista && editando('APOYO_LISTA', a.idApoyoLista))">
              <span class="exl-txt">{{ a.texto }}</span>
              <span class="exl-acc" *ngIf="modoEdicion && a.idApoyoLista">
                <button type="button" class="exl-btn" title="Editar" (click)="editar('APOYO_LISTA', a)"
                        [disabled]="bloqueado('APOYO_LISTA', a.idApoyoLista)">&#9998;</button>
                <button type="button" class="exl-btn" [title]="activo(a) ? 'Desactivar' : 'Activar'"
                        (click)="alternarEstatus('APOYO_LISTA', a)"
                        [disabled]="bloqueado('APOYO_LISTA', a.idApoyoLista) || guardando">{{ activo(a) ? '&#9210;' : '&#9205;' }}</button>
                <button type="button" class="exl-btn rojo" title="Eliminar"
                        (click)="pedirBaja('APOYO_LISTA', a, a.texto || '')"
                        [disabled]="bloqueado('APOYO_LISTA', a.idApoyoLista)">&#10005;</button>
              </span>
            </ng-container>
            <ng-container *ngIf="a.idApoyoLista && editando('APOYO_LISTA', a.idApoyoLista)">
              <input aria-label="Renglón" type="text" class="ha-in exl-in" [(ngModel)]="borrador.texto"
                     [maxlength]="lim.apoyoTexto" [disabled]="guardando">
              <button type="button" class="ha-btn-ok chico" (click)="guardar()" [disabled]="guardando">&#10003;</button>
              <button type="button" class="ha-btn-no chico" (click)="cancelar()" [disabled]="guardando">&#10005;</button>
            </ng-container>
</ng-template>

<!-- El alta de un renglón al pie de una de esas listas. -->
<ng-template #altaApoyo let-lista>
            <ng-container *ngIf="editando('APOYO_LISTA', null) && borrador && borrador.lista === lista">
              <input aria-label="Nuevo renglón…" type="text" class="ha-in exl-in" [(ngModel)]="borrador.texto"
                     [maxlength]="lim.apoyoTexto" [disabled]="guardando" placeholder="Nuevo renglón…">
              <button type="button" class="ha-btn-ok chico" (click)="guardar()" [disabled]="guardando">&#10003;</button>
              <button type="button" class="ha-btn-no chico" (click)="cancelar()" [disabled]="guardando">&#10005;</button>
            </ng-container>
            <button type="button" class="ha-btn-mini"
                    *ngIf="!(editando('APOYO_LISTA', null) && borrador && borrador.lista === lista)"
                    (click)="agregarApoyo(lista)" [disabled]="!!edicion">+ Agregar</button>
</ng-template>

<!-- Una columna de Clasificación de Activos: Hardware o Software. -->
<ng-template #columnaClasificacion let-titulo="titulo" let-lista="lista">
          <div>
            <h5>{{ titulo }}</h5>
            <ul><li *ngFor="let a of apoyoDe(lista); trackBy: rastreaPorId"
              [class.apagado]="!activo(a)"
              [class.en-edicion]="a.idApoyoLista && editando('APOYO_LISTA', a.idApoyoLista)">
            <ng-container *ngTemplateOutlet="renglonApoyo; context: { $implicit: a }"></ng-container>
          </li></ul>
            <div class="exl-alta" *ngIf="modoEdicion">
            <ng-container *ngTemplateOutlet="altaApoyo; context: { $implicit: lista }"></ng-container>
          </div>
          </div>
</ng-template>

<!-- Alta de un criterio de probabilidad (amenazas o vulnerabilidades). -->
<ng-template #panelProbabilidad>
      <div class="ha-alta-grid">
        <label class="corta">
          <span>Aplica a *</span>
          <select class="ha-in" [(ngModel)]="borrador.aplicaA">
            <option *ngFor="let a of APLICA_A" [value]="a">{{ a | titlecase }}</option>
          </select>
        </label>
        <label class="corta">
          <span>Nivel (1 a 4) *</span>
          <input type="number" class="ha-in mini" min="1" max="4" [(ngModel)]="borrador.nivel">
        </label>
        <label>
          <span>Etiqueta *</span>
          <input type="text" class="ha-in" [(ngModel)]="borrador.etiqueta"
                 [maxlength]="lim.probabilidadEtiqueta">
        </label>
        <label class="ancha">
          <span>Criterio</span>
          <textarea class="ha-in" rows="2" [(ngModel)]="borrador.descripcion"
                    [maxlength]="lim.probabilidadDescripcion"></textarea>
        </label>
      </div>
      <div class="ha-alta-pie">
        <button type="button" class="ha-btn-ok" (click)="guardar()" [disabled]="guardando">Guardar</button>
        <button type="button" class="ha-btn-no" (click)="cancelar()" [disabled]="guardando">Cancelar</button>
      </div>
</ng-template>

<!-- La escala de probabilidad de ocurrencia: la de amenazas y la de vulnerabilidades se pintan igual. -->
<ng-template #tablaProbabilidad let-aplica="aplica" let-nombre="nombre">
      <div class="ha-tarjeta">
        <table class="ha-tabla">
          <thead>
            <tr>
              <th class="w-mini">Nivel</th>
              <th class="w-media">Etiqueta</th>
              <th>Criterio</th>
              <th class="w-corta c">Estatus</th>
              <th class="w-acciones" *ngIf="modoEdicion">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let p of probabilidadPor(aplica); trackBy: rastreaPorId"
                [class.en-edicion]="editando('PROBABILIDAD', p.idCatProbabilidad)"
                [class.apagado]="!activo(p)">

              <ng-container *ngIf="!editando('PROBABILIDAD', p.idCatProbabilidad)">
                <td class="c"><strong>{{ p.nivel }}</strong></td>
                <td>{{ p.etiqueta }}</td>
                <td class="td-largo">{{ p.descripcion || '—' }}</td>
                <td class="c"><span class="chip" [ngClass]="activo(p) ? 'chip-on' : 'chip-off'">{{ p.estatus }}</span></td>
                <td class="c nw" *ngIf="modoEdicion">
                  <button type="button" class="ha-btn-edit" (click)="editar('PROBABILIDAD', p)"
                          [disabled]="bloqueado('PROBABILIDAD', p.idCatProbabilidad)">Editar</button>
                  <button type="button" class="ha-btn-estatus" (click)="alternarEstatus('PROBABILIDAD', p)"
                          [disabled]="bloqueado('PROBABILIDAD', p.idCatProbabilidad) || guardando">
                    {{ activo(p) ? 'Desactivar' : 'Activar' }}</button>
                  <button type="button" class="ha-btn-baja"
                          (click)="pedirBaja('PROBABILIDAD', p, nombre + ' nivel ' + p.nivel)"
                          [disabled]="bloqueado('PROBABILIDAD', p.idCatProbabilidad)">Eliminar</button>
                </td>
              </ng-container>

              <ng-container *ngIf="editando('PROBABILIDAD', p.idCatProbabilidad)">
                <td><input aria-label="Nivel" type="number" class="ha-in mini" min="1" max="4" [(ngModel)]="borrador.nivel"></td>
                <td><input aria-label="Etiqueta" type="text" class="ha-in" [(ngModel)]="borrador.etiqueta"
                           [maxlength]="lim.probabilidadEtiqueta"></td>
                <td><textarea aria-label="Criterio" class="ha-in" rows="2" [(ngModel)]="borrador.descripcion"
                              [maxlength]="lim.probabilidadDescripcion"></textarea></td>
                <td>
                  <select aria-label="Estatus" class="ha-in" [(ngModel)]="borrador.estatus">
                    <option value="ACTIVO">ACTIVO</option>
                    <option value="INACTIVO">INACTIVO</option>
                  </select>
                </td>
                <td class="c nw">
                  <button type="button" class="ha-btn-ok" (click)="guardar()" [disabled]="guardando">Guardar</button>
                  <button type="button" class="ha-btn-no" (click)="cancelar()" [disabled]="guardando">Cancelar</button>
                </td>
              </ng-container>
            </tr>
          </tbody>
        </table>
      </div>
</ng-template>
